import { useTranslation } from "react-i18next";

import FunctionalButton from "components/layout/FunctionalButton";
import AnimatedModal from "components/layout/motion/AnimatedModal";

type Props = {
    visible: boolean;
    onCancel: () => void;
};

/**
 * Blocking dialog shown while robot_profile Connect (ethernet + bridge spawn) runs.
 */
const RobotConnectingDialog: React.FC<Props> = ({ visible, onCancel }) => {
    const { t } = useTranslation(["settings", "common"]);

    return (
        <AnimatedModal
            visible={visible}
            onClose={onCancel}
            className="w-full max-w-sm rounded-r10 border border-black80 bg-black100 p-6"
        >
            <p className="text-h4 font-semibold text-white">{t("robot.connecting.title")}</p>
            <p className="mt-2 text-h5 text-black40">{t("robot.connecting.message")}</p>
            <p className="mt-2 text-h5 text-black60">{t("robot.connecting.waitFeedback")}</p>
            <div className="mt-6 flex justify-end">
                <FunctionalButton
                    title={t("common:cancel")}
                    type="button"
                    className="rounded-r5 border border-black60 bg-black90 px-4 py-2 !normal-case text-h5 font-semibold text-white hover:border-black40"
                    onClick={onCancel}
                />
                </div>
        </AnimatedModal>
    );
};

export default RobotConnectingDialog;
